import { defineAsyncComponent } from 'vue'
const IslandRenderer = import.meta.server ? defineAsyncComponent(() => import("/app/node_modules/nuxt/dist/app/components/island-renderer").then(r => r.default || r)) : () => null
export default IslandRenderer